/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as roomActions from '../actions/roomActions';

export function useRoomDetail(roomId: string): { isLoading: boolean; loadRoomDetail: () => Promise<void> } {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();

  async function load() {
    await roomActions.fetchRoomDetail(roomId)(dispatch);
    setIsLoading(false);
  }

  useEffect(() => {
    (async () => await load())();
    return () => roomActions.resetRoomDetail()(dispatch);
  }, [roomId]);

  return { isLoading, loadRoomDetail: load };
}
